import { t } from 'i18next';

import { CourtType, CourtSurfaceType } from '../store/types';

export const courtTypesList: CourtType[] = ['indoor', 'outdoor'];
export const courtSurfaceTypesList: CourtSurfaceType[] = ['clay', 'grass', 'hard'];

export const courtTypesTittle: Record<CourtType, string> = {
  indoor: t('courts.types.indoor'),
  outdoor: t('courts.types.outdoor')
};

export const courtSurfaceTypesTittle: Record<CourtSurfaceType, string> = {
  clay: t('courts.surface-types.clay'),
  grass: t('courts.surface-types.grass'),
  hard: t('courts.surface-types.hard')
};

export const courtsSurfaceTagColors: Record<CourtSurfaceType, string> = {
  'clay': 'volcano',
  'grass': 'green',
  'hard': 'default'
};

export const courtsTypeTagColors: Record<CourtType, string> = {
  'indoor': 'red',
  'outdoor': 'cyan'
};
